// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".desktop-list[data-v-58cef831]{max-height:365px;overflow-y:scroll}.dropdown-items[data-v-58cef831]{top:calc(4rem - 2px)}@media only screen and (min-width:768px){.border-b-white[data-v-58cef831]{border-bottom-color:#fff}}.multiselect-content[data-v-58cef831]{bottom:-50vh;transition:bottom .2s ease-in-out}.multiselect-content.active[data-v-58cef831]{bottom:0;opacity:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
